import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { filter, firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FooterService {
  constructor(private http: HttpClient) {}

  async getFooterList(): Promise<FooterList[]> {
    let response: FooterListResponse;

    response = await firstValueFrom(
      this.http.get<FooterListResponse>("./assets/data/getfooterlist.json")
    );

    return response.footerList;
  }

  async getSocialMediaList(request: {
    partnerCode: string;
  }): Promise<SocialMediaList[]> {
    let response: SocialMediaListResponse;

    response = await firstValueFrom(
      this.http.get<SocialMediaListResponse>(
        "./assets/data/getsocialmedialist.json"
      )
    );

    let filteredList: SocialMediaList[];
    filteredList = response.socialMediaList.filter(
      (obj) => obj.partnerType === request.partnerCode
    );

    return filteredList.length < 1
      ? response.socialMediaList.filter((obj) => obj.partnerType === "ps")
      : filteredList;
  }

  async getPaymentList(): Promise<PaymentListResponse> {
    let response: PaymentListResponse;

    response = await firstValueFrom(
      this.http.get<PaymentListResponse>("./assets/data/getpaymentlist.json")
    );

    return response;
  }
}

interface FooterListResponse {
  footerList: FooterList[];
}

export interface FooterList {
  section: string;
  sectionList: FooterData[];
}

interface FooterData {
  label: string;
  url: string;
}

interface SocialMediaListResponse {
  socialMediaList: SocialMediaList[];
}

export interface SocialMediaList {
  partnerType: string;
  linkList: LinkData[];
}

interface LinkData extends ImageData {
  icon: string;
}

interface PaymentListResponse {
  paymentList: ImageData[];
  bankList: ImageData[];
}

export interface ImageData {
  url: string;
  alt: string;
  title: string;
}
